<template>
  <div
    :class="[
      'notify',
      'notify--' + type,
    ]"
  >
    <font-awesome-icon
      v-if="icon"
      :icon="icon"
      class="notify__icon"
    />
    <h3
      v-if="title"
      v-html="title"
      class="notify__title"
    />
    <h3
      v-if="text"
      v-html="text"
      class="notify__text"
    />
    <slot />
  </div>
</template>

<script>

export default {
  name: 'Notify',
  props: {
    type: {
      type: [String, Number],
      required: false,
      default () {
        return 'success'
      },
    },
    icon: {
      type: [String, Number],
      required: false,
      default () {
        return null
      },
    },
    title: {
      type: [String, Number],
      required: false,
      default () {
        return null
      },
    },
    text: {
      type: [String, Number],
      required: false,
      default () {
        return null
      },
    },
  },
}

</script>

<style lang="scss" scoped>

</style>
